/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, OnInit } from '@angular/core';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { DocumentApi } from '../../sdk/services';
import { MediaHandler } from '../../lib/media.classes';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerComponent } from '../spinner/spinner.component';
import { AuthInterceptor } from '../../sdk/services/core/auth.interceptor'

@Component({
  selector: 'wwg-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {

  uploader: FileUploader;
  baseUploadUrl: string = '/api/admin/profile/type/:type/:id';

  public url;
  private hideImage = true;
  private imageFile;

  constructor(
    private DocumentApi: DocumentApi,
    private dialog: MatDialog
    ) { }

  ngOnInit() {
    new MediaHandler(this.DocumentApi, this.dialog);
    this.uploader = new FileUploader({
      headers: [
        {
          name: 'Authorization',
          value: AuthInterceptor.getAuthorizationHeaderValue()
        }
      ]
    });
    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
  }

  private showSpinner() {
    this.dialog.open(SpinnerComponent, {
      height: '120px',
      width: '300px',
      data: {
        title: 'Profile Picture Uploading'
      }
    });
  }

  /**
   * Read the data of an image as a URL to be used in an HTML src tag
   * @param {any} event The data from the event that triggered the display
   */
  public readUrl(event: any) {
    this.hideImage = false;
    if (event.target.files && event.target.files[0]) {

      let reader = new FileReader();

      reader.onload = (event: any) => {
        this.url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);

      this.imageFile = event.target.files[0];
    }
  }

  public displayExisiting(imgUrl: string) {
    if (imgUrl) {
      this.url = imgUrl;
      this.hideImage = false;
    }
  }


  /**
   * Upload a new profile picture
   */
  public async uploadImage(type: string, id: string) {

    if (this.uploader.queue.length <= 0) {
      return false;
    }

    if (!id) {
      throw new Error('Missing required id parameter for profile upload')
    }

    return this.storeImage(this.baseUploadUrl, {type, id})
      .then((response: any[]) => {
        if (response.find(r => !r.success)) {
          throw new Error('Failed to upload one of the files');
        }
        return response;
      })
      .catch((err) => {
        console.log('Error storing images');
        console.log(err);
        return false;
      });
  }

  private storeImage(baseUploadUrl: string, params: Object) {
    return new Promise((resolve, reject) => {
      try {
        this.uploader.setOptions({
          url: this.DocumentApi._generateURL(baseUploadUrl, params)
        });
        const failedResp = [];

        if (this.uploader.queue.length > 0) {
          this.showSpinner();
          this.uploader.uploadAll();
        } else {
          resolve([]);
        }

        this.uploader.onCompleteAll = () => {
          this.dialog.closeAll();
          resolve(failedResp);
        };

        this.uploader.onCompleteItem = (item: FileItem, response: any) => {
          console.log(response);
          failedResp.push({
            name: item.file.name,
            success: response.success,
            message: response.message,
          });
        };
      } catch (err) {
        console.log("Error uploading profile picture.");
        console.log(err);
        reject(err);
      }
    });
  }
}
